import { _SETTINGS } from 'config/settings';

export const millToTimecode = (seconds: number) => {
  try {
    if (typeof seconds !== 'number') {
      throw new Error('TC format is not valid!');
    }
    let h: number | string = Math.floor(seconds / 3600);
    seconds = seconds - h * 3600;
    let m: number | string = Math.floor(seconds / 60);
    seconds = seconds - m * 60;
    let s: number | string = Math.floor(seconds);
    seconds = seconds - s;
    let f: number | string = Math.floor((seconds * 1000) / 40);
    h = h < 10 ? '0' + h + ':' : h + ':';
    m = String((h && m < 10 ? '0' + m : m) + ':');
    s = (s < 10 ? '0' + s : s) + ':';
    f = f! < 10 ? '0' + f : f;
    return h + m + s + f;
  } catch (err) {
    console.error(err);
  }
};
export const toMS = (currentTimeInSeconds: number) => {
  return Math.ceil(currentTimeInSeconds * 1000);
};
export const toTc = (currentTime: number, framerate: number) => {
  let currentFrame = Number(currentTime * framerate),
    hours = Math.floor(currentTime / 3600),
    minutes = Math.floor(currentTime / 60),
    seconds = Number(currentTime - hours * 3600 - minutes * 60),
    frames = Number(currentFrame % framerate),
    timecodeArray = [hours, minutes, seconds, frames],
    processedTimecodeArray: any[] = [];
  timecodeArray.forEach((time) => {
    if (time < 10) {
      let timeString = '0' + time;
      processedTimecodeArray.push(timeString);
    } else {
      let timeString = time.toString();
      processedTimecodeArray.push(timeString);
    }
  });
  return processedTimecodeArray.join(':');
};
/**
 * Get Frame Num
 */
export const getFrameNum = (actualTime: any) => {
  try {
    if (actualTime !== '' || actualTime !== null) {
      let frameCalc = Math.floor(actualTime * _SETTINGS.basic.frameRate);
      return frameCalc;
    }
  } catch (e) {
    console.error('Error in getFrameNum method');
  }
};
